var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_vm._t("default"),_vm._v(" "),(_vm.$slots.tfoot)?_c('tfoot',[_vm._t("tfoot")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }